import { render } from "./InterventionsManager.vue?vue&type=template&id=36d36bcf&scoped=true"
import script from "./InterventionsManager.vue?vue&type=script&lang=js"
export * from "./InterventionsManager.vue?vue&type=script&lang=js"

import "./InterventionsManager.vue?vue&type=style&index=0&id=36d36bcf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36d36bcf"]])

export default __exports__